import React from 'react'
import styled from 'styled-components';
import { deviceLessThan } from '../../styles/breakpoints';


/**
* BannerContainer
*
*/

export const BannerImageUSP = styled.div`
    display:flex;
    flex:1;
    justify-content: center;
`;

export const BannerContainer = styled.div`
    width: 100%;
    background: ${props => props.background && props.background};
    position:relative;
    &::after{
        content:"";
        position:absolute;
        background:${props => props.backgroundAfter && props.backgroundAfter};
        bottom: -135px;
        transform: rotate(90deg);
        left: 50%;
        width: 60px;
        height: 300px;
        background-size: 60px 300px;
        opacity:0.7
    }
    &::before{
        content:"";
        position:absolute;
        background:${props => props.backgroundAfter && props.backgroundAfter};
        top: -135px;
        transform: rotate(90deg);
        right: 15%;
        width: 60px;
        height: 300px;
        background-size: 60px 300px;
    }
    @media ${deviceLessThan.tablet} {
        background: unset;
        &::after{
            content:"";
            position:absolute;
            background: ${props => props.sBackground && props.sBackground} no-repeat;
            top: ${props => props.sTop ? props.sTop : "8%"};
            right: ${props => props.sRight ? props.sRight : "-61px"};
            width: ${props => props.sWidth ? props.sWidth : "265px"};
            left: unset;
            background-size:${props => props.sBackgroundSize};
            transform: ${props => props.sTransform ? props.sTransform :"rotate(0deg)"};
            height: ${props => props.sHeight ? props.sHeight :"100%"};
        }
        &::before{
            content:"";
            position:absolute;
            background:unset;
            bottom: -22%;
            transform: rotate(90deg);
            left: 50%;
            width: unset;
            height: unset;
        }
    }
`;

export const BannerWrapper = styled.div`
    margin: 50px auto 90px;
    display: flex;
    width:75%;
    max-width: 1200px;
    justify-content: space-between;
    & > div:first-child{
        margin-top: 80px;
        width: 50%;
    };
    @media ${deviceLessThan.tablet} {
        margin:${props => props.sMargin && props.sMargin};
        width:95%;
        flex-direction: column;
        & > div:first-child{
            margin-top: 0px;
            width: 100%;
        };
        text-align:center
    }
    @media ${deviceLessThan.mobileM} {
       width:100%;
       padding:0px 20px
    }
`;

export const PointerImage = styled.div`
    align-self:center;
    margin-right:-20%;
    @media ${deviceLessThan.tablet} {
       margin:30px auto;
       & div{
           margin:10px auto
       }
    }
`;


export const OvalBackground = styled.div`
  position: ${props => props.position ? props.position: 'absolute'};
  width: ${props => props.diameter ? props.diameter: '658px'} !important;
  height: ${props => props.diameter ? props.diameter: '658px'};
  opacity: ${props => props.opacity ? props.opacity: 0.05};
  background: #05caf61c;
  border-radius: 50%;
  top: ${props => props.top && props.top};
  left: ${props => props.left && props.left};
  @media ${deviceLessThan.laptopS} {
      top:${props => props.mTop &&  props.mTop};
      left:${props => props.mLeft &&  props.mLeft};
      height: ${props => props.mDiameter ? props.mDiameter: '400px'};
      width: ${props => props.mDiameter ? props.mDiameter: '400px'} !important;
  }
  @media ${deviceLessThan.tablet} {
    top:${props => props.sTop &&  props.sTop};
    left:${props => props.sLeft &&  props.sLeft};
    height: ${props => props.sDiameter ? props.sDiameter: '200px'};
    width: ${props => props.sDiameter ? props.sDiameter: '200px'} !important;
  }
`;

export const BannerImageWrapper = styled.div`
    position: relative;
    margin:${props => props.margin && props.margin};
    @media ${deviceLessThan.laptop} {
        display:none
    }
    @media ${deviceLessThan.laptopXL} {
        margin:${props => props.xxlMargin && props.xxlMargin};
    }
`;
